export default "__VITE_ASSET__Q1TyjB5A__"